import { StorageKeys } from '@constants/storage-keys.constant'
import LogoLoader from '@components/loader/logo.loader'
import { Language } from '@enums/language.enum'
import { User } from '@interfaces/user.interface'
import { localStorage } from '@services/local-storage.service'
import '@stripe/stripe-js'
import { StrictMode, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App.js'
import { MessagesProvider } from './providers/messages.provider.js'
import { StoreProvider } from './providers/store.provider.js'
import { AppProvider } from './providers/app.provider'

const settings = (localStorage.getItem(StorageKeys.USER) as User)?.settings
// Priority: 1. User settings, 2. Browser language, 3. Default (EN)
export const defaultLocale = settings?.language || navigator?.language?.split('-')[0] || Language.EN

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider>
      <MessagesProvider defaultLocale={defaultLocale}>
        <AppProvider>
          <Router>
            <Suspense fallback={<LogoLoader />}>
              <App />
            </Suspense>
          </Router>
        </AppProvider>
      </MessagesProvider>
    </StoreProvider>
  </StrictMode>,
)
